import { render, staticRenderFns } from "./StakeConfirm.vue?vue&type=template&id=2a2b894c&"
import script from "./StakeConfirm.vue?vue&type=script&setup=true&lang=js&"
export * from "./StakeConfirm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports